import { withI18n } from 'react-i18next';
import PartCard from './PartCard';

export const pureComponent = PartCard;
export default withI18n()(PartCard);
